'use client';

import { BACKEND_API } from '@trwl/backend.api';
import { Path } from '@trwl/shared/lib/router';
import { setDuration, setShow } from '@trwl/store';
import { useUnit } from 'effector-react/compat';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const SearchProductByArticle = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [changeShow, changeDuration] = useUnit([setShow, setDuration]);

  useEffect(() => {
    changeDuration(1000000);
    changeShow(true);
  }, [changeDuration, changeShow]);

  useEffect(() => {
    const article = searchParams.get('article');
    if (article != null) {
      BACKEND_API.ElasticApi.findProductByArticle(article)
        .then(({ data }) => {
          router.replace(`${Path.PRODUCT}/${data}`);
        })
        .catch(() => {
          router.replace(Path.HOME);
        });
    } else {
      router.replace(Path.HOME);
    }
  }, [searchParams, changeDuration, changeShow, router]);
  return <></>;
};
